import { action, thunk, persist } from 'easy-peasy';
import callApi, { generateUrlParams } from '../helpers/ApiAction';

const state = {
  releases: {
    list: [],
    pagination: {
      per_page: 10,
      current_page: 1,
      last_page: 1,
      total: 0
    }
  }
};

const selectors = {
  releaseList: state.releases.list
};

const actions = {
  fetchReleases: thunk(async (actions, payload) => {
    const res = await callApi({
      endpoint: `releases${generateUrlParams(payload)}`,
      method: 'GET'
    });

    const json = await res.json();

    actions.setReleaseList(json);
  }),
  fetchRelease: thunk(async (actions, payload) => {
    const res = await callApi({
      endpoint: `releases/${payload}`,
      method: 'GET'
    });

    const json = await res.json();

    actions.updateRelease(json);
  }),
  updateReleases: thunk(async (actions, payload) => {
    const res = await callApi({
      endpoint: 'releases/refresh',
      method: 'POST'
    });

    const json = await res.json();

    actions.setReleaseList(json);
  }),
  editRelease: thunk(async (actions, payload) => {
    const { uuid, ...release } = payload;

    const res = await callApi({
      endpoint: `releases/${uuid}`,
      method: 'PUT',
      body: release
    });

    const json = await res.json();

    actions.updateRelease(json);
  }),
  updateRelease: action((state, payload) => {
    const {
      data: { release }
    } = payload;

    const releaseIndex = state.releases.list.findIndex(
      ({ uuid }) => release.uuid === uuid
    );

    if (releaseIndex !== -1) {
      state.releases.list[releaseIndex] = release;
    } else {
      state.releases.list.push(release);
    }
  }),
  setReleaseList: action((state, payload) => {
    const {
      data: { releases },
      pagination
    } = payload;

    const { current_page, per_page } = pagination;

    if (current_page === 1 || per_page === 0) {
      state.releases.list = releases;
    } else {
      state.releases.list.push(...releases);
    }

    state.releases.pagination = pagination;
  })
};

export default persist({
  ...state,
  ...selectors,
  ...actions
});
